import envFromHostname from '@toasttab/env-from-hostname'

const env = envFromHostname(window.location.hostname)
const cdnBase = env === 'prod' ? 'https://s3.amazonaws.com/toasttab' : 'https://toast-stage.s3.amazonaws.com'

export const cdnUrl = path => `${cdnBase}${path}`
